import styles from './styles.module.css';
import React, { useState, useEffect } from 'react';
import Head from 'next/head';
import Header from "@/shared/components/Header";
import Footer from "@/shared/components/Footer";
import DatePicker from '@/shared/components/DatePicker';
import ListadoNotas from './components/ListadoNotas';
import { useAppContext } from '@pagegrowler_nextjs';
import Templates from '@/widgets/index';
import Chartbeat from '@/shared/components/Chartbeat';
import PagegrowlerList from '@/widgets/Listado/Templates/PagegrowlerList';


const EdicionAnterior = (props) => {

    const [open, setOpen] = useState(false);
    const LOAD_MORE = 10;
    const pg = useAppContext();
	const Pagegrowler = pg.pagegrowler;

    const {
        title,
        content,
        pagination = {},
        properties
    } = { ...props };

    const stringDate = properties.date;

    const stringYear = stringDate.substr(0, 4);
    const stringMonth = stringDate.substr(4, 2);
    const stringDay = stringDate.substr(6, 2);

    let menues = props.menu ? props.menu : [];

    let [data, setData] = useState([]);
	let [offset, setOffset] = useState(0);

	const [isLoading, setIsLoading] = useState(false);
    const [hideLoadMore, setHideLoadMore] = useState(false);

    useEffect(() => {
		setOffset(pagination.limit + pagination.offset);
		setData(content);
	}, []);

    function pickDateAction(dayObject) {
        if (typeof window !== 'undefined') {
            const pickedYear = ("0000" + dayObject.year).slice(-4);
            const pickedMonth = ("0" + dayObject.month).slice(-2);
            const pickedDay = ("0" + dayObject.day).slice(-2);
            const pickedDate = new Date(`${pickedYear}/${pickedMonth}/${pickedDay}`);
            const dateLimit = new Date('2020/01/01');
            (pickedDate >= dateLimit)
            ? window.location.href = `/edicionesanteriores/${pickedYear}${pickedMonth}${pickedDay}`
            : window.location.href = `/index.php/diarios/${pickedYear}/${pickedMonth}/${pickedDay}/tapa/index.html`
        };
    }

    async function showMoreData() {
		setIsLoading(true);
		let res = await Pagegrowler.loadMoreData(LOAD_MORE, offset);
        if (res.content && res.content.length > 0) {
            setData(prevState => [...prevState, ...res.content]);
            setOffset(offset + LOAD_MORE);
            setIsLoading(false);
        } else {
            setHideLoadMore(true);
        }
		
	}
    let dataLDJson =  {
        "@context": "https://schema.org",
        "@type": "Organization",
        "name": "Diario El Litoral",
        "url": "https://www.ellitoral.com",
        "logo": {
          "@type": "ImageObject",
          "url": `${process.env.NEXT_PUBLIC_DOMAIN_URL}/img/header_logoellitoral.svg`,
          "width": 439,
          "height": 60
        },
        "sameAs": ["https://www.facebook.com/ellitoralcom", "https://instagram.com/ellitoral", "https://twitter.com/ellitoral", "https://plus.google.com/+EllitoralArgentina"]
      };
    return (
        <>
            <Head>
                <title>{`${stringDay}/${stringMonth}/${stringYear} - Ediciones Anteriores - El Litoral`}</title>
                <meta name="description" property="description" content={`Ediciones Anteriores - El Litoral`} />               
                <meta name="og:image" property="og:image" content={`${process.env.NEXT_PUBLIC_DOMAIN_URL}/img/img-default-share.jpeg`} />
                <link rel="image_src" href={`${process.env.NEXT_PUBLIC_DOMAIN_URL}/img/img-default-share.jpeg`} />
                <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(dataLDJson) }} />  
                <meta httpEquiv="refresh" content="600" />
            </Head>
            <Chartbeat />
            <Header menues={menues} isOpenSidePanel={(open) => setOpen(open)} />

            <div className={`${styles['main-container']}`}>
                <div className={`${styles['main-content']}`}>
                {!props.preview && <Templates.BannerHorizontalChico bannerId={'top'}/>}<br/>
                    <div className={`${styles['detail-left']}`}>
                        <div className={`${styles['picker-container']}`}>
                            <DatePicker
                                selectedYear={parseInt(stringYear)}
                                selectedMonth={parseInt(stringMonth)}
                                selectedDay={parseInt(stringDay)}
                                minYear={2004}
                                pickDateAction={pickDateAction}
                            />
                        </div>
                        <div className={`${styles['list-container']}`}>
                            <h3 className={`${styles['date-edition']}`}>Edición Online del día: <strong>{`${stringDay}/${stringMonth}/${stringYear}`}</strong></h3>
                            <ListadoNotas content={data} />
                            <button className={`${styles['button-load-more']} ${styles[hideLoadMore? 'hide': '']}`} disabled={isLoading} onClick={showMoreData}>CARGAR MAS NOTICIAS</button>
                        </div>
                        {!props.preview && <Templates.BannerHorizontalChico bannerId={'horizontal1'}/>}
                    </div>
                    <div className={`${styles['detail-right']}`}>
                        <PagegrowlerList url='column-lilanews'/>
                    </div>
                </div>
            </div>
            <div style={{ clear: 'both' }}>
                <Footer />
            </div>
        </>
    )
}

export default EdicionAnterior;